
import { useSfaStore } from "@/stores/sfa.js";
import { experimentTriggers } from "@/constants/experiments";
import { baseConsts } from "@/constants";

export async function runExperiments(nextPageName, deviceId) {
    const sfaStore = useSfaStore();
    if (!sfaStore.triggeredSiteEntry) {
        await sfaStore.runExperimentsForTriggerAsync({
            deviceId: deviceId,
            triggerEvent: experimentTriggers.SITE_ENTRY,
            triggerValue: baseConsts.SITE_ENTRY_TRIGGER_VALUE,
        }, nextPageName);
    }

    await sfaStore.runExperimentsForTriggerAsync({
        deviceId: deviceId,
        triggerEvent: experimentTriggers.PAGE_ENTRY,
        triggerValue: nextPageName,
    }, nextPageName);
}
